import { Flex } from "@chakra-ui/react";
import { ScopeHeader } from "../ScopeHeader";

function ScopePanel({ children, customHeader, ...rest }) {
  return (
    <Flex flexDirection="column">
      {customHeader ? customHeader : <ScopeHeader {...rest} />}
      {children}
    </Flex>
  );
}

export default ScopePanel;
